import { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import useDarkMode from "../../hooks/useDarkMode";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Sidebar from "./Sidebar";
import { LocaleContext } from "../../i18n/LocaleContext";
import { locales } from '../../i18n/i18n-config'

const Settings = () => {
	const [mode, setMode] = useState('dark')
	const { locale, setLocale } = useContext(LocaleContext);
	const [colorTheme, setTheme] = useDarkMode();
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
	const { currency, sidebar, header, footer, language, role, theme } = result

	const toggleDarkMode = () => {
		setMode(mode == 'dark' ? 'light' : 'dark')
		setTheme(colorTheme);
	};

	const toggleCurrency = (e: any) => {
		dispatch(settings.set({ currency: e }))
	}

	const togglePermission = (e: any) => {
		dispatch(settings.set({ role: e }))
	}
	const handleLanguage = (e: any) => {
		dispatch(settings.set({ language: e }))
	}

	return (
		<div className="w-64  bg-slate-100 text-indigo-500 dark:bg-slate-600 dark:text-indigo-500 h-full overflow-auto fixed top-0 right-0  border-r z-10" id="main-nav">
		<div className="mb-4 px-4">
			<p className="pl-4 text-sm font-semibold mb-1 dark:bg-slate-600 dark:text-yellow-500">THEME</p>
			<div className="flex flex-col items-start justify-center space-y-2 w-full pl-10 py-4 bg-slate-200 rounded-2xl">
				<label className="text-xs flex justify-center" onClick={() => toggleDarkMode()} >
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'darkmode' }))} checked={theme == 'darkmode' ? true : false} /> Dark Mode
				</label>
				<label className="text-xs flex justify-center" onClick={() => toggleDarkMode()}>
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'lightmode' }))} checked={theme == 'lightmode' ? true : false} /> Light Mode
				</label>
				<label className="text-xs flex justify-center" >
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'universal' }))} checked={theme == 'universal' ? true : false} /> Universal Blue
				</label>
				<label className="text-xs flex justify-center" >
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'luxury' }))} checked={theme == 'luxury' ? true : false} />  Luxury Purple
				</label>
				<label className="text-xs flex justify-center" >
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'harmony' }))} checked={theme == 'harmony' ? true : false} />  Harmony Yellow
				</label>
				<label className="text-xs flex justify-center" >
					<input type="radio" className="accent-pink-500 mr-2" onClick={() => dispatch(settings.set({ theme: 'warmth' }))} checked={theme == 'warmth' ? true : false} />  Warmth Green
				</label>
			</div>
		</div>
		{/* <div className="mb-4 px-4">
			<p className="pl-4 text-xs font-semibold mb-1 dark:bg-slate-600 dark:text-yellow-500" > ROLE BASED ACCESS</p>

			<div className="flex flex-col items-start justify-center space-y-2 w-full pl-10 py-4 bg-slate-200 rounded-2xl">
				<div className="text-xs font-bold flex flex-col justify-center space-y-2">
					<div className="flex flex-col justify-between w-32 space-y-1 ">
						<span>App Name  :  </span>
						<select value={'optionsState'} className="text-black text-xs font-normal">
							<option value="A">Fintech</option>
							<option value="B">Fashion</option>
							<option value="C">Commerce</option>
							<option value="C">Food</option>
						</select>
					</div>
					<div className="flex flex-col justify-between w-32  space-y-1  ">
						<span>User  :  </span>
						<select value={'optionsState'}  >
							<option value="A">Raja</option>
							<option value="B">Siva</option>
							<option value="C">Karthik</option>
						</select>
					</div>
					<div className="flex flex-col justify-between w-32 space-y-1 ">
						<span>Layout Route  :  </span>
						<select value={'optionsState'} className="text-black text-xs font-normal" >
							<option value="A">e-Application</option>
							<option value="B">Dashboard</option>
							<option value="C">Analytics</option>
						</select>
					</div>
					<div className="flex flex-col justify-between w-32 space-y-1 ">
						<span>Page Route  :  </span>
						<select value={'optionsState'} className="text-black text-xs font-normal">
							<option value="A">Report</option>
							<option value="B">Graph</option>
							<option value="C">BI</option>
						</select>
					</div>
				</div>

				<label className="text-xs flex justify-center" onClick={() => togglePermission('Reader')} >
					<input type="radio" className="accent-pink-500 mr-2" checked={role == 'Reader' ? true : false} /> Reader
				</label>
				<label className="text-xs flex justify-center" onClick={() => togglePermission('Contributor')}  >
					<input type="radio" className="accent-pink-500 mr-2" checked={role == 'Contributor' ? true : false} /> Contributor
				</label>
				<label className="text-xs flex justify-center" onClick={() => togglePermission('IAM Admin')}  >
					<input type="radio" className="accent-pink-500 mr-2" checked={role == 'IAM Admin' ? true : false} /> IAM Admin
				</label>
				<label className="text-xs flex justify-center" onClick={() => togglePermission('Owner')}  >
					<input type="radio" className="accent-pink-500 mr-2" checked={role == 'Owner' ? true : false} /> Owner
				</label>
			</div>
		</div> */}
		
		<div className="mb-4 px-4">
			<p className="pl-4 text-xs font-semibold mb-1 dark:bg-slate-600 dark:text-yellow-500" > CURRENCY</p>
			<div className="flex flex-col items-start justify-center space-y-2 w-full pl-10 py-4 bg-slate-200 rounded-2xl">
				<label className="text-xs flex justify-center" onClick={() => toggleCurrency('$')} >
					<input type="radio" className="accent-pink-500 mr-2" checked={currency == '$' ? true : false} /> $ US Dollar
				</label>
				<label className="text-xs flex justify-center" onClick={() => toggleCurrency('₹')}  >
					<input type="radio" className="accent-pink-500 mr-2" checked={currency == '₹' ? true : false} /> ₹ Rupee
				</label>
				<label className="text-xs flex justify-center" onClick={() => toggleCurrency('€')}  >
					<input type="radio" className="accent-pink-500 mr-2" checked={currency == '€' ? true : false} /> € Euro
				</label>
			</div>
		</div>
		<div className="mb-4 px-4">
			<p className="pl-4 text-sm font-semibold mb-1 dark:bg-slate-600 dark:text-yellow-500"> LANGUAGE</p>
			<div className="flex flex-col items-start justify-center space-y-2 w-full pl-10 py-4 bg-slate-200 rounded-2xl">
				<label className="text-xs flex justify-center" onClick={() => handleLanguage('en-US')} >
					<input type="radio" className="accent-pink-500 mr-2" checked={language == 'en-US' ? true : false} /> English
				</label>
				<label className="text-xs flex justify-center" onClick={() => handleLanguage('ar-EG')} >
					<input type="radio" className="accent-pink-500 mr-2" checked={language == 'ar-EG' ? true : false} /> Arabic
				</label>
				<label className="text-xs flex justify-center" onClick={() => handleLanguage('hi-IN')} >
					<input type="radio" className="accent-pink-500 mr-2" checked={language == 'hi-IN' ? true : false} /> Hindi
				</label>
			</div>
		</div>
		<div className="mb-4 px-4">
			<p className="pl-4 text-sm font-semibold mb-1 dark:bg-slate-600 dark:text-yellow-500"> LAYOUT VIEW</p>
			<div className="flex flex-col items-start justify-center space-y-2 w-full pl-10 py-4 bg-slate-200 rounded-2xl">
				<label className="text-xs flex justify-center" onClick={() => dispatch(settings.set({ sidebar: !sidebar }))} >
					<input type="checkbox" checked={sidebar} className="accent-pink-500 mr-2" /> Sidebar
				</label>
				<label className="text-xs flex justify-center" onClick={() => dispatch(settings.set({ header: !header }))}>
					<input type="checkbox" className="accent-pink-500 mr-2" checked={header} /> Header
				</label>
				<label className="text-xs flex justify-center" onClick={() => dispatch(settings.set({ footer: !footer }))}>
					<input type="checkbox" className="accent-pink-500 mr-2" checked={footer} /> Footer
				</label>
			</div>
		</div>
	</div >
	)
}

export default Settings;




